import { type PBRMaterial } from '@babylonjs/core/Materials/PBR/pbrMaterial';
import { type Material } from '@babylonjs/core/Materials/material';
import { type MaterialDefines } from '@babylonjs/core/Materials/materialDefines';
import { MaterialPluginBase } from '@babylonjs/core/Materials/materialPluginBase';
import { type AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';
import { type Scene } from '@babylonjs/core/scene';

type LogoMaterial = PBRMaterial & {
  pluginLogo: MaterialPluginBase;
};

/**
 * Extend from MaterialPluginBase to create your plugin.
 */
class LogoPluginMaterial extends MaterialPluginBase {
  constructor(material: Material) {
    // the second parameter is the name of this plugin.
    // the third one is a priority, which lets you define the order multiple plugins are run. Lower numbers run first.
    // the fourth one is a list of defines used in the shader code.
    super(material, 'Logo', 200, { LOGO_DISCARD: false });

    // let's enable it by default
    this._enable(true);
  }

  /**
   * Sets the defines for the next rendering
   * @param defines - the list of "defines" to update.
   * @param scene - defines the scene to the material belongs to.
   * @param mesh - the mesh being rendered
   */
  prepareDefines(defines: MaterialDefines, scene: Scene, mesh: AbstractMesh) {
    scene;
    mesh;
    defines.LOGO_DISCARD = true;
  }

  getClassName() {
    return 'LogoPluginMaterial';
  }

  getCustomCode(shaderType: string) {
    if (shaderType === 'fragment') {
      return {
        CUSTOM_FRAGMENT_MAIN_BEGIN: `
          if (vAlbedoUV.x < 0.0 || vAlbedoUV.x > 1.0 || vAlbedoUV.y < 0.0 || vAlbedoUV.y > 1.0) {
            discard;
          }
        `,
      };
    }
    return null;
  }
}

/**
 * Clone override apply logo material plugin.
 * @param material - Material.
 */
function clone(material: PBRMaterial, name: string): PBRMaterial {
  const materialCopy = material.clone(name);

  // Inject logo plugin material
  const pluginLogo = new LogoPluginMaterial(materialCopy);
  (materialCopy as LogoMaterial).pluginLogo = pluginLogo;

  return materialCopy;
}

export const LogoMaterial = {
  clone,
};
